module.exports = __webpack_public_path__ + "fonts/Graphik-Bold.f7571a0.woff2";